import {Pipe, PipeTransform} from '@angular/core';
import {AppService} from "../services/app.service";

@Pipe({
    name: 'timeAgo',
    standalone: true
})
export class TimeAgoPipe implements PipeTransform {
    constructor(public myapp: AppService) {
    }

    transform(value?: number | string | Date, maxDays: number = 21): string {
        const loginAt = this.myapp.userMetaData?.lastLoginAt;
        if (!loginAt || loginAt < Date.now() - maxDays * 86400000) {
            this.myapp.logout();
            return '⚠️ Session expirée, reconnectez-vous';

        }

        let date: Date;
        if (value instanceof Date) {
            date = value;
        } else if (typeof value === 'number') {
            date = new Date(value);
        } else {
            const num = Number(value);
            date = new Date(isNaN(num) ? value : num);
        }

        if (isNaN(date.getTime())) return '';

        const diffMs = Date.now() - date.getTime();
        if (diffMs < 0) return 'dans le futur';

        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        const parts: string[] = [];

        if (days > 0) {
            parts.push(`${days} j`);
            if (hours % 24 > 0) parts.push(`${hours % 24} h`);
        } else if (hours > 0) {
            parts.push(`${hours} h`);
            if (minutes % 60 > 0) parts.push(`${minutes % 60} min`);
        } else if (minutes > 0) {
            parts.push(`${minutes} min`);
            if (seconds % 60 > 0) parts.push(`${seconds % 60} sec`);
        } else {
            parts.push(`${seconds} sec`);
        }

        return `il y a ${parts.slice(0, 2).join(' ')}`;
    }
}